import React from "react";
import styles from "./NoAccess.module.styl";

export default function NoAccess() {
    return (
        <p className={styles.text} data-test-name="no-access-text">У вас нет доступа к просмотру информации на данной странице.</p>
    );
}
